import {BCMSRecord ,BCMSRecordProperty} from "bcms-react"; 
import { Transaction } from "model";
/**
* @class CheckTransaction
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.checkTransaction[0];
* const transaction = new CheckTransaction(record);
* @property {NUMBER} _mapID - The id of the transaction for related check data
* @property {NUMBER} _number - the number on the check
* @property {STRING} _memo - memo on check
*/
export default class CheckTransaction extends BCMSRecord{
    _mapID;   
    _number;  
    _memo;   

    constructor (record){   
      super(Object.assign(record,Transaction.initByID(record.mapID).record)) 
    }    
  } 
  CheckTransaction.define({
    "recordType":"checkTransactions",
    "recordIDProp":"mapID",
    "className" : "CheckTransaction",
    "recordProperties":[
      /** 
      * @name mapID
      * @instance
      * @property get {NUMBER} - gets the mapID of the check
      * @property set {NUMBER} - sets the mapID of the check
      * @memberof CheckTransaction 
      */
      BCMSRecordProperty.mapToNumber("mapID","_mapID"),
      /** 
      * @name number
      * @instance
      * @property get {NUMBER} - gets the number of the check
      * @property set {NUMBER} - sets the number of the check
      * @memberof CheckTransaction 
      */
      BCMSRecordProperty.mapToNumber("number","_number"),
      /** 
      * @name memo
      * @instance
      * @property get {STRING} - gets the memo of the check
      * @property set {STRING} - sets the memo of the check
      * @memberof CheckTransaction 
      */
      BCMSRecordProperty.mapToString("memo","_memo")    
    ].concat(Transaction._RecordProperties)
})




